module.exports = __webpack_public_path__ + "public/SideMenuIcons/failedPayout.svg?80ec91c1";